export interface SelectedBar {
  /* index of step */
  index: number;
  /* index of bar in step */
  barIdx: number;
  /* type of bar */
  type: BarType;
}

export enum BarType {
  CONVERTED = `converted`,
  DROP_OFF = `drop-off`,
}

export enum CountType {
  RELATIVE = `relative`,
  ABSOLUTE = `absolute`,
}

interface BarData {
  /* conversion to the next step in its respective funnel between 0 - 1 */
  conversionToNext: number;
  /* conversion from the last step in its respective funnel between 0 - 1 */
  conversionRate?: number;
  /* count of the bar */
  value: number;
  /* color used to override default color scheme */
  color: string;
  /* name of the segment represented by the bar (when compare funnels is used) */
  segmentName?: string;
}

interface BarWithSize extends BarData {
  /* between 0 - 100 */
  convertedBarHeight: number;
  /* between 0 - 100 */
  dropOffBarHeight: number;
}

export interface Step {
  /* the data for the bars to be displayed in this step */
  data: BarData[];
  /* specifies if a step should render an empty column */
  empty?: string;
  /* sources name of the step */
  event?: string;
  color?: string;
  subheader: string;
  title: string;
  tootipText: string;
}

/** A step where all sub-segments have computed heights */
export interface ChartableStep extends Step {
  data: BarWithSize[];
}

export type SelectBarEvent = CustomEvent<{
  /** step index of the bar */
  index: number;
  /** sub-index within the step in the case of multiple series */
  barIdx: number;
  /** which part of the bar was clicked */
  type: BarType;
  /** original mouse event (for positioning) */
  mouseEvent: MouseEvent;
}> & {type: `selectBar`};

export type SelectColumnEvent = CustomEvent<{
  /** step index of the column */
  index: number;
}> & {type: `selectColumn`};

export type ClosePopoverEvent = CustomEvent<{}> & {type: `closePopover`};

export type UpdateStartStepEvent = CustomEvent<{
  /** new starting index for the chart */
  index: number;
}> & {type: `updateStartStep`};

export type ContextMenuStepEvent = CustomEvent<{
  step: ChartableStep;
  mouseEvent: MouseEvent;
}> & {type: `contextMenuStep`};
